<template>
  <div class="forget">
    <main-header></main-header>

    <div class="forget--container shadow-card">
      <div class="section-title">
        Пожалуйста, введите свой адрес электронной почты. На него будет отправлена ссылка для восстановления пароля.
        Обращаем ваше внимание, что ссылка будет работать в течение 20 минут.
      </div>
      <div v-if="error.status" class="alert alert-danger mrg-t-25">
        {{error.text}}
      </div>
      <div v-if="success" class="alert alert-success mrg-t-25">
        Письмо со ссылкой для восстановления пароля успешно отправлено
      </div>
      <div class="input-block mrg-t-25">
        <label for="login-email">Адрес электронной почты</label>
        <input
            type="email"
            @focus="clearAlerts"
            v-model="email"
            id="login-email"
        />
      </div>
      <div class="input-block">
        <div @click="sendEmail" class="btn btn-sm btn-success">Отправить</div>
      </div>

      <div class="mrg-t-30">
        <hr>
        <div class="mrg-t-20 text-right">
          <router-link class="btn btn-sm btn-info" tag="a" :to="`/login/`">Войти</router-link>
          <router-link class="btn btn-sm btn-info" tag="a" :to="`/register/`">Регистрация</router-link>
        </div>
      </div>

    </div>


    <main-footer></main-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import MainHeader from "../components/site/MainHeader";
import MainFooter from "../components/site/MainFooter";
import { mapState } from "vuex";
import authRepository from "../repositories/auth";

export default {
  name: "Forget",
  components: {
    MainFooter,
    MainHeader
  },
  data() {
    return {
      email: "",
      error: {
        status: false,
        text: ''
      },
      success: false
    };
  },
  computed: {
    ...mapState({
      userData: state => state.authorization.userData
    })
  },
  methods: {
    clearAlerts(){
      this.success = false;
      this.error.status = false;
      this.error.text = '';
    },
    sendEmail(){
      this.$store.dispatch("startPreloader");
      authRepository.forgetSend({email: this.email.trim()}).then(resp => {
        if(resp.data.result === 'ok'){
          this.success = true;
        }else{
          this.error.status = true;
          this.error.text = 'Ошибка';
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.error.status = true;
        this.error.text = err.response.data.message;
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {
    if (this.userData) {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped lang="less">
.forget--container {
  width: 500px;
  min-height: 65vh;
  margin: 40px auto 60px auto;
}
@media (max-width: 700px) {
  .forget--container {
    width: 98%;
  }
}
</style>
